import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { userActions } from "../../_actions";
import { AdminMessage, Routes } from "../../_components";
import { userConstants } from "../../_constants";
import "../../assets/css/requestCheckNew.css";
import SEARCH_ICON from "../../assets/images/search-var-flat.png";
import { List, Item, Banner, ItemEmpty } from "../../_components/ListSnjob";
import { BtnRound } from "../../_components/BtnRound";
import { formatDate } from "../../_helpers/formatDate";
import { ModalSnjob } from "../../_components/ModalSnjob";
import { CardSelect } from "../../_components/pdp-card-select";

class RequestCheckSupervisorNew_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCourse: null,
      activeRequest: null,
      advance_search: false,
      commentModal: false,
      jobGroupOptions: [],
      newCourses: [],
      requests: [],
      requestModal: false,
    };
  }

  componentDidMount = () => {
    const hasCode3015 = JSON.parse(localStorage.getItem("globalStorage"))
      .value.access.flatMap(({ access_code }) => access_code?.split("-") ?? [])
      .includes("3015");
    if (!hasCode3015) {
      userActions.failure("برای شما در این بخش دسترسی تعریف نشده است");
      this.props.history.push("/pdpSites");
    } else {
      this.getJobGroups();
      this.getRequestedCourses();
      document.querySelector(".wave").classList.add("hidden");
    }
  };

  componentDidUpdate = (props, state) => {
    if (
      state.activeRequest !== this.state.activeRequest &&
      this.state.activeRequest !== null
    ) {
      this.getTitles();
    }
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  getRequestedCourses = (job_group = null, post_name = null) => {
    const jobGroupUrl = job_group ? `job_group=${job_group}` : "";
    const postNameUrl = post_name ? `&post_name=${post_name}` : "";

    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/supervisor/requested_courses?${jobGroupUrl}${postNameUrl}`,
          null,
          true,
          false
        )
      )
      .then((res) => {
        this.setState({
          requests: res.data.map(({ requested_courses, user }) => {
            return {
              requested_courses: requested_courses.map((request) => ({
                ...request,
                like_status: null,
              })),
              user,
              supervisor_description: null,
            };
          }),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getJobGroups = () => {
    this.props
      .dispatch(userActions.API("get", `v1/hospital/job_groups`))
      .then((res) => {
        this.setState({
          jobGroupOptions: res.data.map(({ id, name }) => ({
            id,
            name,
          })),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getTitles = () => {
    const { requests, activeRequest } = this.state;
    const request = requests[activeRequest];
    const selectedIdsByUser = request.requested_courses.map(
      (obj) => obj.course_id
    );

    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/course/titles?job_group=${request.user.post.job_group}`,
          null,
          true
        )
      )
      .then((res) => {
        const notSelectedByUser = res.data.filter(
          (course) => !selectedIdsByUser.includes(course.id)
        );
        this.setState({
          newCourses: notSelectedByUser.map((course) => ({
            ...course,
            like_status: null,
          })),
          titles: res.data,
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putResponse = () => {
    const { activeRequest, requests, newCourses } = this.state;
    const { requested_courses, user, supervisor_description } =
      requests[activeRequest];
    const { user_id } = user.post;
    if (
      requested_courses.some(
        ({ like_status, course }) =>
          (like_status === null || like_status === 0) &&
          course.course_type !== "2"
      )
    )
      return userActions.failure("همه نیازسنجی ها را تعیین نظر کنید");
    const oldRequests = requests[activeRequest].requested_courses
      .map(({ like_status, course_id, supervisor_comment, course }) => ({
        course_id,
        action:
          (like_status === null || like_status === 0) &&
          course.course_type === "2"
            ? "accept"
            : like_status === 4
            ? "accept"
            : like_status === 2
            ? "accept"
            : like_status === 1
            ? "reject"
            : "invalid",
        comment:
          like_status === 4
            ? null
            : like_status === 1
            ? supervisor_comment === null
              ? "رد شده توسط سازمان"
              : supervisor_comment
            : null,
        supervisor_description,
      }))
      .filter((obj) => obj.action !== "invalid");
    if (oldRequests.length === 0) {
      return userActions.failure("لطفا همه نیازسنجی ها را انتخاب کنید");
    }
    const newRequests = newCourses
      .filter(({ like_status }) => like_status !== null)
      .map(({ id }) => ({
        course_id: id,
        action: "add",
        comments: "کامنت سازمان",
        requested_by: "supervisor",
        supervisor_description,
      }));
    const data = {
      user_id,
      courses: [...oldRequests, ...newRequests],
      supervisor_description,
    };
    // if like 0 no select
    // if like 1 like
    // if like 2 dislike
    // if like 3 add
    // if like 4 elzami

    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/user/hospital/supervisor/modify_courses`,
          data
        )
      )
      .then(() => {
        this.getRequestedCourses();
        this.reset();
        userActions.successToast("نظر شما با موفقیت ثبت شد.");
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  reset = () => {
    this.setState({
      activeRequest: null,
      activeCourse: null,
      advance_search: false,
      commentModal: false,
      requestModal: false,
      requests: this.state.requests.map(({ requested_courses, user }, i) => ({
        requested_courses: requested_courses.map((request) => ({
          ...request,
          like_status: null,
        })),
        user,
        superior_description: null,
        supervisor_description: null,
      })),
    });
  };

  onCloseModal = (func) => {
    this.props
      .dispatch(userActions.question("انصراف", "آیا از انصراف مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          func();
        }
      });
  };

  onSubmitModal = (func) => {
    this.props
      .dispatch(userActions.question("تایید", "آیا از تایید مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          func();
        }
      });
  };

  copyLikes = () => {
    const { requests, activeRequest } = this.state;
    requests[activeRequest].requested_courses.forEach(
      ({ course, status, superior_comment, requested_by }, i) => {
        let superiorLike;
        if (status === "superior_pending") {
          superiorLike = course.course_type === "2" ? 0 : 0;
        }
        if (status === "supervisor_pending") {
          superiorLike =
            course.course_type === "2"
              ? 0
              : requested_by === "superior"
              ? 2
              : superior_comment && superior_comment.length === 0
              ? 1
              : 2;
        }
        if (status === "rejected_by_superior") {
          superiorLike = 1;
        }
        if (status === "rejected_by_supervisor") {
          superiorLike =
            course.course_type === "2"
              ? 0
              : requested_by === "superior"
              ? 2
              : superior_comment === null || superior_comment.length === 0
              ? 2
              : 1;
        }
        requests[activeRequest].requested_courses[i].like_status = superiorLike;
      }
    );
    this.setState({ requests });
  };

  resetLikes = () => {
    const { requests, activeRequest } = this.state;
    requests[activeRequest].requested_courses.forEach((_, i) => {
      requests[activeRequest].requested_courses[i].like_status = 0;
    });
    this.setState({ requests });
  };

  render() {
    const {
      titles,
      advance_search,
      requests,
      activeRequest,
      commentModal,
      activeCourse,
      newCourses,
      requestModal,
    } = this.state;

    const user_comment = requests[activeRequest]
      ? requests[activeRequest].requested_courses[0].user_comment
      : null;
    const superior_description = requests[activeRequest]
      ? requests[activeRequest].requested_courses[0].superior_description
      : null;
    const submitted_at = requests[activeRequest]
      ? requests[activeRequest].requested_courses[0].submitted_at
      : null;
    const superior_submitted_at = requests[activeRequest]
      ? requests[activeRequest].requested_courses[0].superior_submitted_at
      : null;

    return (
      <div className="requestCheckNew bg-light bg-drr pt-3 pb-5 px-3">
        <Routes page="pdp/requestEdu" />
        <div className="container-fluid">
          <div className="card bg-white shadow text-center border-0">
            <AdminMessage />
          </div>
        </div>
        <NotifCard
          className="mt-4"
          text1="کاربران حاضر در لیست فوق برای شما درخواست دوره خود را ارسال نموده اند شما می توانید به این نیازسنجی ها رسیدگی کنید."
        />
        <SearchSection
          // searchTitle={searchTitle}
          advance_search={advance_search}
          onAdvance={() => this.setState({ advance_search: !advance_search })}
          // jobGroupValue={jobGroupValue}
          // jobGroupOptions={jobGroupOptions}
          // postsOptions={postsOptions}
          // postValue={postValue}
          // dispatch={dispatch}
          // onJobGroup={(e) => this.setState({ jobGroupValue: e }, () => this.getRequestedCourses(e.id))}
        />
        <br />
        <div className="container-fluid px-3 pb-5">
          <div className="row">
            <div className="col-lg-12 col-md-12 m-auto">
              <List className="transparent-scroll container-fluid px-0 py-4">
                <ul
                  className="list position-relative w-100 m-0 p-2"
                  style={{
                    boxShadow: "none",
                  }}
                >
                  <Banner
                    className="py-3"
                    grid="1fr 2fr 2fr 3fr 2fr 2fr 2fr 4fr 1fr"
                    key={0}
                  >
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      ردیف
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      نام
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      نام خانوادگی
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      تاریخ درخواست
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      سمت
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      گروه شغلی
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      بخش
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      وضعیت
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      اعمال نظر
                    </div>
                  </Banner>
                  {requests.length ? (
                    requests.map(({ user, requested_courses }, i) => {
                      const {
                        submitted_at,
                        status,
                        requested_by,
                        superior_comment,
                      } = requested_courses[0];

                      let statusText = "xxx";

                      if (
                        requested_by === "user" &&
                        status === "superior_pending"
                      ) {
                        // statusText =
                        // 	course.course_type === '2'
                        // 		? 'الزامی توسط سازمان'
                        // 		: 'در انتظار اعمال نظر توسط مافوق و سازمان';
                        statusText = "در انتظار اعمال نظر توسط مافوق و سازمان";
                      }
                      if (
                        requested_by === "user" &&
                        status === "supervisor_pending"
                      ) {
                        // statusText =
                        // 	course.course_type === '2'
                        // 		? 'الزامی توسط سازمان'
                        // 		: `${
                        // 				superior_comment && superior_comment.length === 0 ? '' : 'تایید توسط مافوق'
                        // 		  } در انتظار اعمال نظر توسط سازمان`;
                        statusText = `${
                          superior_comment && superior_comment.length === 0
                            ? ""
                            : "تایید توسط مافوق"
                        } در انتظار اعمال نظر توسط سازمان`;
                      }
                      if (
                        requested_by === "user" &&
                        status === "rejected_by_superior"
                      ) {
                        // statusText =
                        // 	course.course_type === '2'
                        // 		? 'الزامی توسط سازمان'
                        // 		: 'رد شده توسط مافوق در انتظار اعمال نظر توسط سازمان';
                        statusText =
                          "رد شده توسط مافوق در انتظار اعمال نظر توسط سازمان";
                      }
                      if (
                        requested_by === "user" &&
                        status === "rejected_by_supervisor"
                      ) {
                        // statusText = course.course_type === '2' ? 'الزامی توسط سازمان' : 'رد توسط سازمان';
                        statusText = "رد توسط سازمان";
                      }
                      if (requested_by === "user" && status === "active") {
                        // statusText = course.course_type === '2' ? 'الزامی توسط سازمان' : 'موافقت نهایی';
                        statusText = "موافقت نهایی";
                      }
                      if (
                        requested_by === "superior" &&
                        status === "supervisor_pending"
                      ) {
                        statusText =
                          "درخواست توسط مافوق و در انتظار اعمال نظر توسط سازمان";
                      }
                      if (
                        requested_by === "superior" &&
                        status === "rejected_by_supervisor"
                      ) {
                        statusText = "رد درخواست مافوق توسط سازمان";
                      }
                      if (requested_by === "superior" && status === "active") {
                        statusText = "درخواست توسط مافوق و تایید توسط سازمان";
                      }
                      if (
                        requested_by === "supervisor" &&
                        status === "active"
                      ) {
                        statusText = "موافقت نهایی مطابق نظر سازمان";
                      }

                      const jobGroupText = user.post.job_group
                        ? user.post.job_group.length > 20
                          ? user.post.job_group.slice(0, 20) + "..."
                          : user.post.job_group
                        : "گروه شغلی ندارید";
                      const jobLocationText = user.post.job_location
                        ? user.post.job_location.length > 20
                          ? user.post.job_location.slice(0, 20) + "..."
                          : user.post.job_location
                        : "بخـش ندارید";

                      const unseen =
                        status !== "rejected_by_supervisor" &&
                        status !== "active";

                      return (
                        <Item
                          className="py-1"
                          grid="1fr 2fr 2fr 3fr 2fr 2fr 2fr 4fr 1fr"
                          key={i + 1}
                        >
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {i + 1}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {user.firstname}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {user.lastname}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {formatDate(submitted_at)}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {user.post.name}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {jobGroupText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {jobLocationText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p
                              className={`itemComp__text text-center text-primary m-0 ${
                                unseen && "unseen"
                              }`}
                            >
                              {statusText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <BtnRound
                              className="apply-comment-logo rounded-circle"
                              onClick={() =>
                                this.setState({
                                  requestModal: true,
                                  activeRequest: i,
                                })
                              }
                            />
                          </div>
                        </Item>
                      );
                    })
                  ) : (
                    <ItemEmpty />
                  )}
                </ul>
              </List>
            </div>
          </div>

          {activeRequest !== null && (
            <ModalSnjob
              title={`${requests[activeRequest].user.firstname} ${requests[activeRequest].user.lastname} - ${requests[activeRequest].user.post.job_group}`}
              className="requestCheckNew"
              isOpen={requestModal}
              onClose={() => this.onCloseModal(this.reset)}
            >
              <div
                className="row mb-4 d-flex justify-content-center align-items-center"
                style={{ gap: "2rem" }}
              >
                {user_comment && (
                  <CardSelect
                    hideHeader={true}
                    hideTitle={true}
                    style={{ height: "20vh", overflow: "scroll" }}
                    text={user_comment}
                    customTitle={
                      <div
                        className="d-flex justify-content-between align-items-center px-3 py-2"
                        style={{ width: "280px" }}
                      >
                        <p className="m-0 text-primary">کاربر</p>
                        <p className="m-0 text-primary iran-sans-imp">
                          {formatDate(submitted_at)}
                        </p>
                      </div>
                    }
                  />
                )}
                {superior_description && (
                  <CardSelect
                    hideHeader={true}
                    hideTitle={true}
                    style={{ height: "20vh", overflow: "scroll" }}
                    text={superior_description}
                    customTitle={
                      <div
                        className="d-flex justify-content-between align-items-center px-3 py-2"
                        style={{ width: "280px" }}
                      >
                        <p className="m-0 text-primary">مافوق</p>
                        <p className="m-0 text-primary iran-sans-imp">
                          {formatDate(superior_submitted_at)}
                        </p>
                      </div>
                    }
                  />
                )}
                <CardSelect
                  hideHeader={true}
                  hideTitle={true}
                  hideContent={true}
                  style={{ height: "20vh", overflow: "scroll" }}
                  onClick={() =>
                    document.getElementById("supervisor_description").focus()
                  }
                >
                  <div className="d-flex justify-content-between align-items-center px-3 py-2">
                    <p className="m-0 text-primary">نظر شما</p>
                  </div>
                  <Textarea
                    className="special-textarea-2"
                    value={requests[activeRequest].supervisor_description}
                    onChange={(e) => {
                      requests[activeRequest].supervisor_description =
                        e.target.value;
                      this.setState({ requests });
                    }}
                    style={{ padding: "0px 16px 20px 16px", fontSize: "12px" }}
                    id="supervisor_description"
                  />
                </CardSelect>
              </div>

              <List
                className="transparent-scroll"
                container="container-fluid"
                padding="px-0"
                style={{ height: "45vh" }}
              >
                <ul
                  className="list position-relative w-100 m-0 p-2"
                  style={{
                    boxShadow: "none",
                  }}
                >
                  <Banner
                    className="py-3"
                    grid="1fr 2fr 4fr 2fr 2fr 2fr 1fr"
                    key={0}
                  >
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      ردیف
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      وضعیت انتخاب کاربر
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      عنوان دوره
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      فراوانی انتخاب دوره
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      نظر مافوق
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      ارسال نظر نهایی
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      دلیل رد کردن
                    </div>
                  </Banner>
                  {requests[activeRequest].requested_courses.map(
                    (
                      {
                        course,
                        course_id,
                        like_status,
                        status,
                        superior_comment,
                        requested_by,
                      },
                      i
                    ) => {
                      const temp =
                        titles !== undefined && titles.length !== 0
                          ? titles.find((obj) => obj.id === course_id)
                          : null;
                      const total_requests = temp ? temp.total_requests : 0;
                      let superiorIcon;
                      if (status === "superior_pending") {
                        superiorIcon =
                          course.course_type === "2" ? "tick-dark" : "waiting";
                      }
                      if (status === "supervisor_pending") {
                        superiorIcon =
                          course.course_type === "2"
                            ? "tick-dark"
                            : requested_by === "superior"
                            ? "tick"
                            : superior_comment && superior_comment.length === 0
                            ? "dislike"
                            : "like";
                      }
                      if (status === "rejected_by_superior") {
                        superiorIcon = "dislike";
                      }
                      if (status === "rejected_by_supervisor") {
                        superiorIcon =
                          course.course_type === "2"
                            ? "tick-dark"
                            : requested_by === "superior"
                            ? "tick"
                            : superior_comment === null ||
                              superior_comment.length === 0
                            ? "like"
                            : "dislike";
                      }

                      return (
                        <Item
                          className="py-1"
                          grid="1fr 2fr 4fr 2fr 2fr 2fr 1fr"
                          key={i + 1}
                        >
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {i + 1}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            {requested_by !== "superior" ? (
                              <BtnRound
                                data_tip={`${
                                  course.course_type === "2"
                                    ? "دوره الزامی"
                                    : course.course_type === "1"
                                    ? "دوره عمومی"
                                    : "دوره اختیاری"
                                }`}
                                className={`${
                                  course.course_type === "2"
                                    ? "tick-dark"
                                    : "tick"
                                }-logo`}
                              />
                            ) : (
                              "-"
                            )}
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {course.title}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {total_requests}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <BtnRound className={`${superiorIcon}-logo`} />
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <BtnRound
                              className={`${
                                course.course_type !== "2"
                                  ? like_status === 1
                                    ? "dislike"
                                    : like_status === 2
                                    ? "like"
                                    : like_status === 4
                                    ? "tick-dark"
                                    : "like-dark"
                                  : "tick-dark"
                              }-logo`}
                              onClick={() => {
                                if (like_status !== 4) {
                                  requests[activeRequest].requested_courses[
                                    i
                                  ].like_status =
                                    like_status === 0 || like_status === null
                                      ? 2
                                      : like_status === 2
                                      ? 1
                                      : 0;
                                  this.setState({ requests });
                                } else {
                                  userActions.failure(
                                    "این دوره الزامی سازمان می باشد."
                                  );
                                }
                              }}
                            />
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <BtnRound
                              className={`doctor${
                                course.course_type !== "2"
                                  ? superiorIcon === "dislike" ||
                                    like_status === 1
                                    ? ""
                                    : "-dark"
                                  : "-dark"
                              }-logo rounded-circle`}
                              onClick={() =>
                                (superiorIcon === "dislike" ||
                                  like_status === 1) &&
                                this.setState({
                                  commentModal: true,
                                  requestModal: false,
                                  activeCourse: i,
                                })
                              }
                            />
                          </div>
                        </Item>
                      );
                    }
                  )}
                  {newCourses.length &&
                    newCourses.map(
                      ({ title, total_requests, like_status }, i) => {
                        return (
                          <Item
                            className="py-1"
                            grid="1fr 2fr 4fr 2fr 2fr 2fr 1fr"
                            key={
                              requests[activeRequest].requested_courses.length +
                              i +
                              1
                            }
                          >
                            <div
                              className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                              style={{ gap: "10px", fontSize: "15px" }}
                            >
                              <p className="itemComp__text text-center text-primary m-0">
                                {requests[activeRequest].requested_courses
                                  .length +
                                  i +
                                  1}
                              </p>
                            </div>
                            <div
                              className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                              style={{ gap: "10px", fontSize: "15px" }}
                            >
                              <p className="itemComp__text text-center text-primary m-0">
                                -
                              </p>
                            </div>
                            <div
                              className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                              style={{ gap: "10px", fontSize: "15px" }}
                            >
                              <p className="itemComp__text text-center text-primary m-0">
                                {title}
                              </p>
                            </div>
                            <div
                              className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                              style={{ gap: "10px", fontSize: "15px" }}
                            >
                              <p className="itemComp__text text-center text-primary m-0">
                                {total_requests}
                              </p>
                            </div>
                            <div
                              className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                              style={{ gap: "10px", fontSize: "15px" }}
                            >
                              -
                            </div>
                            <div
                              className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                              style={{ gap: "10px", fontSize: "15px" }}
                            >
                              <BtnRound
                                className={`${
                                  like_status === null || like_status === 0
                                    ? "empty"
                                    : like_status === 3
                                    ? "tick"
                                    : null
                                }-logo`}
                                onClick={() => {
                                  newCourses[i].like_status =
                                    like_status === 3 ? 0 : 3;
                                  this.setState({ newCourses });
                                }}
                              />
                            </div>
                            <div
                              className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                              style={{ gap: "10px", fontSize: "15px" }}
                            ></div>
                          </Item>
                        );
                      }
                    )}
                </ul>
              </List>
              <div className="d-flex flex-row-reverse align-items-center mt-2 w-100 px-4">
                <p className=" font-weight-bold my-0 mr-2 text-right w-100 style_text title_box">
                  مطابق با نظر مافوق تایید گردد.
                </p>
                <input
                  type="checkbox"
                  className="copy-likes-btn"
                  onClick={() => {
                    const value =
                      document.querySelector(".copy-likes-btn").checked;
                    value ? this.copyLikes() : this.resetLikes();
                  }}
                />
              </div>

              <div className=" d-flex justify-content-center align-items-center w-100 mt-3">
                <button
                  className="btn btn-primary rounded-pill btn_supervisior mx-2"
                  onClick={() => this.onSubmitModal(this.putResponse)}
                >
                  <p className="m-0 py-2 IRANSansWeb">
                    ثبت نهایی و ارسال به سازمان
                  </p>
                </button>
                <button
                  className="btn rounded-pill btn_empty mx-2"
                  onClick={() => this.onCloseModal(this.reset)}
                >
                  <p className="m-0 py-2 IRANSansWeb">انصراف</p>
                </button>
              </div>
            </ModalSnjob>
          )}
          {activeRequest !== null && activeCourse !== null && (
            <ModalSnjob
              title="دلیل رد کردن"
              className="requestCheckNew"
              isOpen={commentModal}
              onClose={() =>
                this.setState({ requestModal: true, commentModal: false })
              }
            >
              {requests[activeRequest].requested_courses[activeCourse]
                .like_status === 1 && (
                <div className=" w-100 px-4 mb-2 d-inline-block">
                  <p className=" font-weight-bold w-100 text-right px-3 style_text title_box">
                    نظر خود را ارسال نمایید.
                  </p>
                  <Textarea
                    value={
                      requests[activeRequest].requested_courses[activeCourse]
                        .supervisor_comment
                    }
                    onChange={(e) => {
                      requests[activeRequest].requested_courses[
                        activeCourse
                      ].supervisor_comment = e.target.value;
                      this.setState({ requests });
                    }}
                    placeholder="رد شده توسط سازمان"
                    style={{ padding: "15px 20px 20px 20px" }}
                    className="special-textarea"
                  />
                </div>
              )}
              <div className=" w-100 px-4 mb-2 d-inline-block">
                <p className=" font-weight-bold w-100 text-right px-3 style_text title_box">
                  نظر مافوق
                </p>
                <Textarea
                  value={
                    requests[activeRequest].requested_courses[activeCourse]
                      .superior_comment
                  }
                  onChange={(e) => {
                    requests[activeRequest].requested_courses[
                      activeCourse
                    ].superior_comment = e.target.value;
                    this.setState({ requests });
                  }}
                  placeholder="رد شده توسط مافوق"
                  style={{ padding: "15px 20px 20px 20px" }}
                  className="special-textarea"
                />
              </div>
            </ModalSnjob>
          )}
        </div>
      </div>
    );
  }
}

class SearchSection extends Component {
  render() {
    const {
      advance_search,
      onAdvance,
      searchTitle,
      jobGroupValue,
      jobGroupOptions,
      postsOptions,
      postValue,
      onJobGroup,
    } = this.props;

    return (
      <div className="note bg-white mx-5 py-3 mt-4">
        <div className="row  ">
          <div className="col-lg-10 m-auto  ">
            <div className=" d-inline-block w-100 px-4 mt-2">
              <Input
                // value={searchTitle}
                // onChange={(e) =>
                // }
                placeholder="کلید واژه مورد نظر خود را انتخاب کنید"
              />
            </div>
          </div>
        </div>
        <div
          className="row d-flex justify-content-center my-4 "
          onClick={onAdvance}
        >
          <div className="bg-blue w-25 my-3" style={{ height: "2px" }}></div>
          <button className="btn btn-link px-3 py-0">
            <img src={SEARCH_ICON} alt="" width="40" height="40" />
          </button>
          <div className="bg-blue w-25 my-3" style={{ height: "2px" }}></div>
        </div>
        {advance_search && (
          <div className="animated fadeIn">
            <div className="d-flex justify-content-center px-sm-5 ">
              <div className="col-md-4  col-sm-8  ">
                <div className="select-wrapper">
                  <div className=" d-inline-block w-100 px-4">
                    <p className=" w-100 text-right IRANSansWeb px-3 style_text title_box">
                      گروه شغلی
                    </p>
                    <SelectType
                      // value={jobGroupValue}
                      // options={jobGroupOptions}
                      // onChange={(e) => {
                      // 	onJobGroup(e);
                      // }}
                      placeholder="فیلتر بر اساس گروه شغلی"
                    />
                  </div>
                </div>
              </div>

              <div className=" col-md-4   col-sm-8  ">
                <div className="select-wrapper">
                  <div className=" d-inline-block w-100 px-4">
                    <p className=" w-100 text-right IRANSansWeb px-3 style_text title_box">
                      سمت
                    </p>
                    <SelectType
                      // value={postValue}
                      // options={postsOptions}
                      // onChange={(e) => {
                      // }}
                      // isClearable
                      placeholder="فیلتر بر اساس سمت"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        )}
      </div>
    );
  }
}

class Input extends Component {
  render() {
    const { value, onChange, placeholder } = this.props;
    return (
      <input
        name="name"
        type="text"
        className="form-control rounded-pill text-center py-1"
        aria-label="Full Name"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    );
  }
}

class SelectType extends Component {
  render() {
    const { value, onChange, options, placeholder, isMulti, isClearable } =
      this.props;
    const selectStyle = {
      container: (baseStyles) => ({
        ...baseStyles,
        height: "50px",
      }),
      control: (baseStyles) => ({
        ...baseStyles,
        padding: "6px 10px 6px 5px",
        height: "100%",
        borderRadius: "50px",
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        zIndex: "999",
        textAlign: "right",
      }),
    };

    const multiSelectStyle = {
      control: (baseStyles) => ({
        ...baseStyles,
        padding: "6px 10px 6px 5px",
        boxShadow: "0px 0px 4px 1px #ccc",
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        zIndex: "999",
        textAlign: "right",
      }),
    };

    return (
      <>
        {isMulti ? (
          <Select
            isMulti
            styles={multiSelectStyle}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />
        ) : isClearable ? (
          <Select
            styles={selectStyle}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
            isClearable
          />
        ) : (
          <Select
            styles={selectStyle}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />
        )}
      </>
    );
  }
}

class NotifCard extends Component {
  render() {
    const {
      text1,
      text2,
      color1 = "#777777",
      color2 = "#6c00ff",
      className,
    } = this.props;

    return (
      <div className={`notif py-3 px-5 ${className}`}>
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </div>
    );
  }
}

class Textarea extends Component {
  render() {
    return (
      <textarea
        className={`${this.props.className}`}
        placeholder={`${this.props.placeholder || ""}`}
        value={this.props.value || ""}
        onChange={this.props.onChange}
        style={this.props.style}
        id={this.props.id}
      />
    );
  }
}

const RequestCheckSupervisorNew = connect((state) => ({
  globalStorage: state.globalStorage,
}))(RequestCheckSupervisorNew_);
export { RequestCheckSupervisorNew };
